import React from 'react';

import type { OptionType, ValueContainerProps } from '@atlaskit/select';
import { components } from '@atlaskit/select';

import MultiValuePopup from './MultiValuePopup';

type Props<Option extends OptionType> = {
  optionsLimit: number;
} & ValueContainerProps<Option, boolean>;

export default function MultiValueContainerWithOverflow<
  Option extends OptionType
>({ optionsLimit, ...rest }: Props<Option>): JSX.Element {
  const getChildren = () => {
    const items = rest.children[0] ?? [];
    const input = rest.children[1];

    const areItemsOverflowing = items.length > optionsLimit;

    if (areItemsOverflowing) {
      const displayedItems = items.slice(0, optionsLimit);
      const overflowedItems = items.slice(optionsLimit);

      const OverflowingItemsInPopup = (
        <MultiValuePopup overflowValues={overflowedItems} />
      );

      const newItems = [...displayedItems, OverflowingItemsInPopup];
      return [newItems, input];
    }

    return rest.children;
  };

  return (
    <components.ValueContainer {...rest}>
      {getChildren()}
    </components.ValueContainer>
  );
}
